import React from "react";
import styled from "styled-components";

import {
  Grid,
  List,
  ListItemText,
  ListItem as MuiListItem
} from "@mui/material";

const Wrapper = styled.div`
  padding: ${props => props.theme.spacing(0.25)}
    ${props => props.theme.spacing(4)};
  background: ${props => props.theme.palette.common.white};
  position: relative;
`;

const ListItem = styled(MuiListItem)`
  display: inline-block;
  width: auto;
  padding-left: ${props => props.theme.spacing(2)};
  padding-right: ${props => props.theme.spacing(2)};

  &,
  &:hover,
  &:active {
    color: #000;
  }
`;

function Footer() {
  return (
    <Wrapper>
      <Grid container spacing={0}>
        <Grid container size={{ xs: 12, md: 6 }} sx={theme => ({ [theme.breakpoints.down("md")]: { display: "none" } })}>
        </Grid>
        <Grid container size={{ xs: 12, md: 6 }} sx={{ justifyContent: "flex-end" }}>
          <List>
            <ListItem>
              <ListItemText primary={`© ${new Date().getFullYear()} - Masterplan ERP Inc.`} />
            </ListItem>
          </List>
        </Grid>
      </Grid>
    </Wrapper>
  );
}

export default Footer;
